import { useTextConversionMethod } from "@/lib/prismicio/useTextConversion"
import { Link, cn, useFacetExcessive } from "@jog/react-components"
import { FacetAttribute } from "@jog/types"

const LinkItem = ({ item, className, root }: { item: FacetAttribute; className?: string; root: boolean }) => {
    const textConvert = useTextConversionMethod()
    return (
        <li className={className}>
            {item.link ? (
                <Link href={item.link} className={cn({ "font-bold": item.isselected })}>
                    {`${root ? "" : "- "}${textConvert(item.title)}`}
                </Link>
            ) : (
                <></>
            )}
            {item.children ? (
                <ul className="space-y-3.75 pl-1.5 pt-3.75">
                    {item.children.map((child, index) => (
                        <LinkItem key={index} item={child} root={false} />
                    ))}
                </ul>
            ) : (
                <></>
            )}
        </li>
    )
}

export const LinkFacet = () => {
    const { display, Showmore, facet } = useFacetExcessive()
    if (!facet) return
    return (
        <div className="mt-2">
            <ul className="space-y-3.75">
                {facet.attributes
                    .filter((_, index) => display(index))
                    .map((attribute, index) => (
                        <LinkItem key={index} item={attribute} root={true} />
                    ))}
            </ul>
            <Showmore className="mt-1.25 py-1 text-base lg:hover:text-red-mona" />
        </div>
    )
}
